import { ReactElement } from 'react'

import { QuoteInvoiceState } from '../../../../../../../../enums/quoteInvoiceState'
import * as Styled from './styles'

interface QuoteInvoicedStatusDotProps {
  invoiceState?: QuoteInvoiceState
  label: string
}

export const QuoteInvoicedStatusDot = ({ invoiceState, label }: QuoteInvoicedStatusDotProps): ReactElement => {
  const isRing = invoiceState === QuoteInvoiceState.PartiallyInvoiced

  return <Styled.QuoteInvoicedStatusDotWrapper aria-label={label} isRing={isRing} role="img" title={label} />
}
